const e = {
  "hero-teaser": "hero-teaser",
  "hero-teaser__info-container": "hero-teaser__info-container",
  "hero-teaser__text-container": "hero-teaser__text-container",
  "hero-teaser__title-container": "hero-teaser__title-container",
  "hero-teaser__title": "hero-teaser__title",
  "hero-teaser__overline": "hero-teaser__overline",
  "hero-teaser__button-container": "hero-teaser__button-container",
  "hero-teaser__media-container": "hero-teaser__media-container",
  "hero-teaser__media-container--contain": "hero-teaser__media-container--contain",
  "hero-teaser--unpublished": "hero-teaser--unpublished"
};
export {
  e as default
};
